import {Browser} from '@clappr/core'
export {default} from './template'
export {default as classNames} from './styles.scss'

export const options = {
  allowUserInteraction: false
}

const LARGE_WIDTH_BREAKPOINT = 570
const LARGE_HEIGHT_BREAK_POINT = 320

const VERTICAL_PADDINGS_SUM = 2 * 30
const LARGE_TITLE_MIN_HEIGHT = 20 + 5 + 1 * 30 + VERTICAL_PADDINGS_SUM
const LARGE_TITLE_MAX_HEIGHT = 20 + 5 + 2 * 30 + VERTICAL_PADDINGS_SUM
const SMALL_TITLE_MAX_HEIGHT = 20 + 5 + 2 * 25 + VERTICAL_PADDINGS_SUM

const WATCH_NEXT_VISIBILITY_HEIGHT_BREAKPOINT = Browser.isMobile ? 175 : 205

const SMALL_WATCH_NEXT_MIN_HEIGHT = 75 + 5 + 3 * 15 + 10
const THREE_LINES_WATCH_NEXT_MIN_HEIGHT = 85 + 10 + 3 * 20 + 15

const ONE_LINE_WATCH_NEXT_HEIGHT = 105 + 10 + 1 * 20 + 15
const TWO_LINES_WATCH_NEXT_HEIGHT = 105 + 10 + 2 * 20 + 15
const THREE_LINES_WATCH_NEXT_HEIGHT = 105 + 10 + 3 * 20 + 15

export const getContainerClassNames = ({
  width,
  height,
  suggestHeight,
  docking,
  title,
  likes,
  episodes
}: {
  width: number
  height: number
  suggestHeight: number | null
  docking: boolean
  title: boolean
  likes: boolean
  episodes: boolean
}): [string, boolean][] => {
  const availableHeight =
    suggestHeight == null ? height : height - suggestHeight

  const tinySuggest = suggestHeight != null && height < 210
  const fullHeightSuggest = suggestHeight != null && availableHeight < 120

  const playerHeight = fullHeightSuggest ? height : availableHeight

  const largeContainerWidth = width >= LARGE_WIDTH_BREAKPOINT
  const largeContainerHeight = height >= LARGE_HEIGHT_BREAK_POINT
  const largePlayerHeight = playerHeight >= LARGE_HEIGHT_BREAK_POINT

  let largeTitle

  if (suggestHeight != null && !fullHeightSuggest) {
    largeTitle =
      Browser.isMobile || docking
        ? largeContainerWidth && LARGE_TITLE_MAX_HEIGHT <= availableHeight
        : largeContainerWidth && LARGE_TITLE_MIN_HEIGHT <= availableHeight
  } else {
    largeTitle = largeContainerWidth && largeContainerHeight
  }

  const titleMaxHeight = largeTitle
    ? LARGE_TITLE_MAX_HEIGHT
    : SMALL_TITLE_MAX_HEIGHT
  const shortenTitle = playerHeight < titleMaxHeight

  /* WATCH NEXT */
  const shiftableHeight = playerHeight - (0 + 2 * 15 + 5)
  const activeTopShift = title || likes ? 35 : 0
  const activeShiftableHeight = playerHeight - (activeTopShift + 2 * 15 + 35)

  let watchNextVariant
  let activeWatchNextVariant
  let watchNextSize

  if (Browser.isMobile) {
    let watchNextHiddenTextHeightBreakpoint

    watchNextVariant = 3

    if (shiftableHeight >= THREE_LINES_WATCH_NEXT_MIN_HEIGHT) {
      watchNextSize = 'large'
      watchNextHiddenTextHeightBreakpoint = THREE_LINES_WATCH_NEXT_MIN_HEIGHT
    } else {
      watchNextHiddenTextHeightBreakpoint = SMALL_WATCH_NEXT_MIN_HEIGHT
    }

    if (
      watchNextHiddenTextHeightBreakpoint &&
      activeShiftableHeight < watchNextHiddenTextHeightBreakpoint
    )
      activeWatchNextVariant = 0
  } else {
    watchNextSize = 'large'

    if (shiftableHeight >= THREE_LINES_WATCH_NEXT_HEIGHT) watchNextVariant = 3
    else if (shiftableHeight >= TWO_LINES_WATCH_NEXT_HEIGHT)
      watchNextVariant = 2
    else if (shiftableHeight >= ONE_LINE_WATCH_NEXT_HEIGHT) watchNextVariant = 1

    if (watchNextVariant) {
      if (activeShiftableHeight >= THREE_LINES_WATCH_NEXT_HEIGHT)
        activeWatchNextVariant = 3
      else if (activeShiftableHeight >= TWO_LINES_WATCH_NEXT_HEIGHT)
        activeWatchNextVariant = 2
      else if (activeShiftableHeight >= ONE_LINE_WATCH_NEXT_HEIGHT)
        activeWatchNextVariant = 1
      else activeWatchNextVariant = 0
    }
  }

  const watchNextHidden =
    suggestHeight != null ||
    playerHeight < WATCH_NEXT_VISIBILITY_HEIGHT_BREAKPOINT

  // BOTTOM + BOTTOM PADDING + (LABEL HEIGHT + LABEL TOP MARGIN) + IMAGE HEIGHT + TOP PADDING + TOP
  const hideThumbnails =
    availableHeight <
    35 + 12 + (episodes ? 15 + 5 : 0) + 29 + 15 + (title ? 35 : 0)

  // BOTTOM + BOTTOM PADDING + TWO LINES LABEL HEIGHT + LABEL TOP MARGIN + IMAGE HEIGHT + TOP PADDING + TOP
  const episodesWithTwoLines =
    largeContainerWidth &&
    largeContainerWidth &&
    availableHeight >= 35 + 12 + 2 * 15 + 5 + 60 + 15 + (title ? 35 : 0)

  const fullscreenSettingsMenu =
    Browser.isMobile || !largeContainerWidth || !largeContainerWidth

  return [
    ['eplayer-fullscreen-menu', fullscreenSettingsMenu],
    ['eplayer-normal-menu', !fullscreenSettingsMenu],
    ['eplayer-tiny-suggest', tinySuggest],
    ['eplayer-full-height-suggest', fullHeightSuggest],
    ['eplayer-shorten-title', shortenTitle],
    ['eplayer-large-title', largeTitle],
    ['eplayer-large-screen', largeContainerWidth && largePlayerHeight],
    ['eplayer-large-size', largeContainerWidth && largeContainerHeight],
    ['eplayer-large-height', largePlayerHeight],
    ['eplayer-watch-next-hidden', watchNextHidden],
    ['eplayer-watch-next-large', watchNextSize === 'large'],
    ['eplayer-watch-next-one-line', watchNextVariant === 1],
    ['eplayer-watch-next-two-lines', watchNextVariant === 2],
    ['eplayer-watch-next-three-lines', watchNextVariant === 3],
    ['eplayer-active-watch-next-hidden-text', activeWatchNextVariant === 0],
    ['eplayer-active-watch-next-one-line', activeWatchNextVariant === 1],
    ['eplayer-active-watch-next-two-lines', activeWatchNextVariant === 2],
    ['eplayer-active-watch-next-three-lines', activeWatchNextVariant === 3],
    ['eplayer-hide-thumbnails', hideThumbnails],
    ['eplayer-episodes-one-line', episodes && !episodesWithTwoLines],
    ['eplayer-episodes-two-lines', episodes && episodesWithTwoLines]
  ]
}
